/* eslint-disable @typescript-eslint/no-explicit-any */

import { CMS_SITE_ORIGIN } from "@danishagro/shared/src/constants/urlRoot.constants";

export const useFileUpload = () => {
    const checkForFileFields = (body: any) => {
        const fileFields = [] as string[];

        for (const key in body) {
            if (body?.[key] instanceof File && body?.[key]?.size > 0) {
                fileFields.push(key);
            }
        }

        const hasFile = typeof fileFields?.[0] !== "undefined";

        return { hasFile, fileFields };
    };

    const uploadFile = async (file: File) => {
        try {
            const formData = new FormData();
            formData.append("file", file);

            // Make a fetch POST request to send the file to the server
            const request = await fetch(`${CMS_SITE_ORIGIN}/SaveFormFile`, {
                method: "POST",
                body: formData,
            });

            if (request.ok) {
                const response = await request.text();
                if (response.startsWith("http")) {
                    return [true, response];
                }

                throw new Error(`Unexpected response ${response}`);
            }

            throw new Error(`HTTP error! status: ${request.status}`);
        } catch (error: any) {
            console.log(error);
        }
    };

    return {
        checkForFileFields,
        uploadFile,
    };
};
